// index.js

import React, { Suspense, useEffect, useState } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import { useSelector } from "react-redux";

 
 
function IntercomInit() {

  const intercomData = useSelector((state) => state.SharedData.settings?.intercomData)



  useEffect(() => {
     Intercom(intercomData)
  }, [intercomData])

  return (
    <React.Fragment>
    </React.Fragment>
  );
}


export default IntercomInit